export default "__VITE_ASSET__dd090688__"